import { request } from "@/utils/request";

 
export function GetItemById(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Coursecategory/GetItemByIdFront",
    params,
  });
}

export function GetPage(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Coursecategory/GetPageFront",
    params,
  });
}

export function GetClassIntroductionPage(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Coursecategory/GetClassIntroductionPage",
    params,
  });
}

 